module.exports = __webpack_public_path__ + "static/RockstarsGreen.1a46eba0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/RockstarsGreen.svg
// module id = 344
// module chunks = 255246127382036